// Generated by Avo VERSION 169.76.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "bfw5Ar5sJv07ebGgCGKH";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "B8cBqdlOqu8zpNOMjFxK",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "YlokXVpIQVXO68TO4Rm5",
          "se": (new Date()).toISOString(),
          "so": "xnN_A-eeJ",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "B8cBqdlOqu8zpNOMjFxK",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "YlokXVpIQVXO68TO4Rm5",
          "se": (new Date()).toISOString(),
          "so": "xnN_A-eeJ",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "YlokXVpIQVXO68TO4Rm5",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface ExistingProduct {
  itemId: string
  itemName: string
  quantity: number
  itemCategory: string | null | undefined
  itemCategory2: string | null | undefined
  price: number
  itemBrand: string | null | undefined
  itemVariant: string[] | null | undefined
}

export interface DeurTotDeur {
  
}

export interface Items {
  itemId: string
  itemName: string
  coupon: string | null | undefined
  discount: number | null | undefined
  index: number | null | undefined
  quantity: number
  price: number
  itemBrand: string | null | undefined
  itemVariant: string[] | null | undefined
  itemCategory: string | null | undefined
  travelDate: string | null | undefined
  affiliation: string | null | undefined
  itemCategory2: string | null | undefined
  destinationStation: string | null | undefined
  originStation: string | null | undefined
  travelClass: string | null | undefined
  travelRoute: string | null | undefined
  intercityDirect: boolean | null | undefined
  deurTotDeur: DeurTotDeur[] | null | undefined
  itemRevenue: number
}

export const Platform = {
  'WEB': 'web',
  'I_O_S': 'iOS',
  'ANDROID': 'android',
  'MFEP': 'MFEP',
} as const;
export type PlatformType = typeof Platform;
export type PlatformValueType = PlatformType[keyof PlatformType];

export const PaymentType = {
  'IDEAL': 'Ideal',
  'CREDIT_CARD': 'Credit Card',
} as const;
export type PaymentTypeType = typeof PaymentType;
export type PaymentTypeValueType = PaymentTypeType[keyof PaymentTypeType];

export const Schema = {
  'IGLU_NL_NS_LOGIN_START_JSONSCHEMA_1_0_0': 'iglu:nl.ns/login_start/jsonschema/1-0-0',
  'IGLU_NL_NS_LOGIN_ERROR_JSONSCHEMA_1_0_0': 'iglu:nl.ns/login_error/jsonschema/1-0-0',
  'IGLU_NL_NS_VIEW_JSONSCHEMA_1_0_0': 'iglu:nl.ns/view/jsonschema/1-0-0',
  'IGLU_NL_NS_CART_REMOVE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/cart_remove/jsonschema/1-0-0',
  'IGLU_NL_NS_CHAT_START_JSONSCHEMA_1_0_0': 'iglu:nl.ns/chat_start/jsonschema/1-0-0',
  'IGLU_NL_NS_CHECKOUT_PROGRESS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/checkout_progress/jsonschema/1-0-0',
  'IGLU_NL_NS_CHECKOUT_START_JSONSCHEMA_1_0_0': 'iglu:nl.ns/checkout_start/jsonschema/1-0-0',
  'IGLU_NL_NS_CONTENT_SHARE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/content_share/jsonschema/1-0-0',
  'IGLU_NL_NS_COOKIE_CHANGE_PERMISSION_JSONSCHEMA_1_0_0': 'iglu:nl.ns/cookie_change_permission/jsonschema/1-0-0',
  'IGLU_NL_NS_EXPERIMENT_SUCCESS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/experiment_success/jsonschema/1-0-0',
  'IGLU_NL_NS_FILE_DOWNLOAD_JSONSCHEMA_1_0_0': 'iglu:nl.ns/file_download/jsonschema/1-0-0',
  'IGLU_NL_NS_FORM_ERROR_JSONSCHEMA_1_0_0': 'iglu:nl.ns/form_error/jsonschema/1-0-0',
  'IGLU_NL_NS_FORM_START_JSONSCHEMA_1_0_0': 'iglu:nl.ns/form_start/jsonschema/1-0-0',
  'IGLU_NL_NS_ITEM_SELECT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/item_select/jsonschema/1-0-0',
  'IGLU_NL_NS_ITEM_VIEW_JSONSCHEMA_1_0_0': 'iglu:nl.ns/item_view/jsonschema/1-0-0',
  'IGLU_NL_NS_KEUZEHULP_CLICK_JSONSCHEMA_1_0_0': 'iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0',
  'IGLU_NL_NS_LEAD_GENERATE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/lead_generate/jsonschema/1-0-0',
  'IGLU_NL_NS_NBA_SUCCESS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/nba_success/jsonschema/1-0-0',
  'IGLU_NL_NS_PAGE_ERROR_JSONSCHEMA_1_0_0': 'iglu:nl.ns/page_error/jsonschema/1-0-0',
  'IGLU_NL_NS_PUSH_CONSENT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/push_consent/jsonschema/1-0-0',
  'IGLU_NL_NS_REGISTRATION_START_JSONSCHEMA_1_0_0': 'iglu:nl.ns/registration_start/jsonschema/1-0-0',
  'IGLU_NL_NS_REGISTRATION_SUCCESS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/registration_success/jsonschema/1-0-0',
  'IGLU_NL_NS_REISPLANNER_ERROR_JSONSCHEMA_1_0_0': 'iglu:nl.ns/reisplanner_error/jsonschema/1-0-0',
  'IGLU_NL_NS_REISPLANNER_SUCCESS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/reisplanner_success/jsonschema/1-0-0',
  'IGLU_NL_NS_REISREGISSEUR_CHANGE_PERMISSION_JSONSCHEMA_1_0_0': 'iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0',
  'IGLU_NL_NS_REISVERGELIJKER_START_JSONSCHEMA_1_0_0': 'iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0',
  'IGLU_NL_NS_REISVERGELIJKER_SUCCESS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0',
  'IGLU_NL_NS_SCROLL_JSONSCHEMA_1_0_0': 'iglu:nl.ns/scroll/jsonschema/1-0-0',
  'IGLU_NL_NS_SEARCH_START_JSONSCHEMA_1_0_0': 'iglu:nl.ns/search_start/jsonschema/1-0-0',
  'IGLU_NL_NS_VIDEO_COMPLETE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/video_complete/jsonschema/1-0-0',
  'IGLU_NL_NS_VIDEO_PROGRESS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/video_progress/jsonschema/1-0-0',
  'IGLU_NL_NS_VIDEO_START_JSONSCHEMA_1_0_0': 'iglu:nl.ns/video_start/jsonschema/1-0-0',
  'IGLU_NL_NS_VISIT_QUALIFIED_JSONSCHEMA_1_0_0': 'iglu:nl.ns/visit_qualified/jsonschema/1-0-0',
  'IGLU_NL_NS_APP_CLEAR_DATA_JSONSCHEMA_1_0_0': 'iglu:nl.ns/app_clear_data/jsonschema/1-0-0',
  'IGLU_NL_NS_PURCHASE_INTENTION_JSONSCHEMA_1_0_0': 'iglu:nl.ns/purchase_intention/jsonschema/1-0-0',
  'IGLU_NL_NS_SESSION_COUNT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/session_count/jsonschema/1-0-0',
  'IGLU_NL_NS_SESSION_START_JSONSCHEMA_1_0_0': 'iglu:nl.ns/session_start/jsonschema/1-0-0',
  'IGLU_NL_NS_FORM_SUBMIT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/form_submit/jsonschema/1-0-0',
  'IGLU_NL_NS_KEUZEHULP_SUCCESS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0',
  'IGLU_NL_NS_WIDGET_ADD_JSONSCHEMA_1_0_0': 'iglu:nl.ns/widget_add/jsonschema/1-0-0',
  'IGLU_NL_NS_WIDGET_REMOVE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/widget_remove/jsonschema/1-0-0',
  'IGLU_NL_NS_STATION_JSONSCHEMA_1_0_0': 'iglu:nl.ns/station/jsonschema/1-0-0',
  'IGLU_NL_NS_DETAIL_CLICK_JSONSCHEMA_1_0_0': 'iglu:nl.ns/detail_click/jsonschema/1-0-0',
  'IGLU_NL_NS_VOORZIENINGEN_CLICK_JSONSCHEMA_1_0_0': 'iglu:nl.ns/voorzieningen_click/jsonschema/1-0-0',
  'IGLU_NL_NS_KAART_CLICK_JSONSCHEMA_1_0_0': 'iglu:nl.ns/kaart_click/jsonschema/1-0-0',
  'IGLU_NL_NS_MODALITIES_FILTER_JSONSCHEMA_1_0_0': 'iglu:nl.ns/modalities_filter/jsonschema/1-0-0',
  'IGLU_NL_NS_PLAN_VANAF_HIER_JSONSCHEMA_1_0_0': 'iglu:nl.ns/plan_vanaf_hier/jsonschema/1-0-0',
  'IGLU_NL_NS_TRAJECT_ADD_JSONSCHEMA_1_0_0': 'iglu:nl.ns/traject_add/jsonschema/1-0-0',
  'IGLU_NL_NS_TRAJECT_REMOVE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/traject_remove/jsonschema/1-0-0',
  'IGLU_NL_NS_TRAJECT_SEINTJES_JSONSCHEMA_1_0_0': 'iglu:nl.ns/traject_seintjes/jsonschema/1-0-0',
  'IGLU_NL_NS_NOTIFICATION_RECEIVE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/notification_receive/jsonschema/1-0-0',
  'IGLU_NL_NS_NOTIFICATION_OPEN_JSONSCHEMA_1_0_0': 'iglu:nl.ns/notification_open/jsonschema/1-0-0',
  'IGLU_NL_NS_NOTIFICATION_FOREGROUND_JSONSCHEMA_1_0_0': 'iglu:nl.ns/notification_foreground/jsonschema/1-0-0',
  'IGLU_NL_NS_NOTIFICATION_DISMISS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/notification_dismiss/jsonschema/1-0-0',
  'IGLU_NL_NS_APP_EXCEPTION_JSONSCHEMA_1_0_0': 'iglu:nl.ns/app_exception/jsonschema/1-0-0',
  'IGLU_NL_NS_APP_REMOVE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/app_remove/jsonschema/1-0-0',
  'IGLU_NL_NS_APP_UPDATE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/app_update/jsonschema/1-0-0',
  'IGLU_NL_NS_OS_UPDATE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/os_update/jsonschema/1-0-0',
  'IGLU_NL_NS_SERVER_PURCHASE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/server_purchase/jsonschema/1-0-0',
  'IGLU_NL_NS_REMOVE_FROM_CART_JSONSCHEMA_1_0_0': 'iglu:nl.ns/remove_from_cart/jsonschema/1-0-0',
  'IGLU_NL_NS_LOGIN_SUCCESS_JSONSCHEMA_2_0_3': 'iglu:nl.ns/login_success/jsonschema/2-0-3',
  'IGLU_NL_NS_PAGE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/page/jsonschema/1-0-0',
  'IGLU_NL_NS_COOKIE_CONSENT_SUBMIT_JSONSCHEMA_2_0_2': 'iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2',
  'IGLU_NL_NS_COOKIE_CONSENT_VIEW_JSONSCHEMA_2_0_2': 'iglu:nl.ns/cookie_consent_view/jsonschema/2-0-2',
  'IGLU_NL_NS_LOGIN_STATUS_UPDATE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/login_status_update/jsonschema/1-0-0',
  'IGLU_NL_NS_CLASS_CHANGE_CONFIRM_JSONSCHEMA_1_0_0': 'iglu:nl.ns/class_change_confirm/jsonschema/1-0-0',
  'IGLU_NL_NS_CLASS_CHANGE_SET_JSONSCHEMA_1_0_0': 'iglu:nl.ns/class_change_set/jsonschema/1-0-0',
  'IGLU_NL_NS_NBA_CONTEXT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/nba_context/jsonschema/1-0-0',
  'IGLU_NL_NS_SCREEN_CONTEXT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/screen_context/jsonschema/1-0-0',
  'IGLU_NL_NS_TEST_EVENT_VARIANT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/test_event_variant/jsonschema/1-0-0',
  'IGLU_NL_NS_FEEDBACK_GIVE_JSONSCHEMA_1_0_2': 'iglu:nl.ns/feedback_give/jsonschema/1-0-2',
  'IGLU_NL_NS_CONSENT_CONTEXT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/consent_context/jsonschema/1-0-0',
  'IGLU_NL_NS_PURCHASE_INTENTION_CONTEXT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/purchase_intention_context/jsonschema/1-0-0',
  'IGLU_NL_NS_GLOBAL_CONTEXTS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/global_contexts/jsonschema/1-0-0',
  'IGLU_NL_NS_LOST_AND_FOUND_SEARCH_CATEGORY_JSONSCHEMA_1_0_0': 'iglu:nl.ns/lost_and_found_search_category/jsonschema/1-0-0',
  'IGLU_NL_NS_LOST_AND_FOUND_SEARCH_TERM_JSONSCHEMA_1_0_0': 'iglu:nl.ns/lost_and_found_search_term/jsonschema/1-0-0',
  'IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1_0_7': 'iglu:nl.ns/screen_view/jsonschema/1-0-7',
  'IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_1_0_5': 'iglu:nl.ns/add_to_cart/jsonschema/1-0-5',
  'IGLU_NL_NS_TRAVEL_PLANNER_PLAN_JOURNEY_JSONSCHEMA_1_0_0': 'iglu:nl.ns/travel_planner_plan_journey/jsonschema/1-0-0',
  'IGLU_NL_NS_AUTHENTICATION_JSONSCHEMA_1_0_0': 'iglu:nl.ns/authentication/jsonschema/1-0-0',
  'IGLU_NL_NS_BANNER_CLICK_JSONSCHEMA_1_0_3': 'iglu:nl.ns/banner_click/jsonschema/1-0-3',
  'IGLU_NL_NS_CART_ADD_JSONSCHEMA_1_0_3': 'iglu:nl.ns/cart_add/jsonschema/1-0-3',
  'IGLU_NL_NS_CHECKBOX_CLICK_JSONSCHEMA_1_0_3': 'iglu:nl.ns/checkbox_click/jsonschema/1-0-3',
  'IGLU_NL_NS_CHIP_FILTER_CLICK_JSONSCHEMA_1_0_3': 'iglu:nl.ns/chip_filter_click/jsonschema/1-0-3',
  'IGLU_NL_NS_CLICK_JSONSCHEMA_1_0_2': 'iglu:nl.ns/click/jsonschema/1-0-2',
  'IGLU_NL_NS_CLICKED_OPTION_JSONSCHEMA_1_0_1': 'iglu:nl.ns/clicked_option/jsonschema/1-0-1',
  'IGLU_NL_NS_COOKIE_CONSENT_CHANGE_JSONSCHEMA_1_0_2': 'iglu:nl.ns/cookie_consent_change/jsonschema/1-0-2',
  'IGLU_NL_NS_DATEPICKER_CLICK_JSONSCHEMA_1_0_3': 'iglu:nl.ns/datepicker_click/jsonschema/1-0-3',
  'IGLU_NL_NS_ELEMENT_CLICK_JSONSCHEMA_1_0_2': 'iglu:nl.ns/element_click/jsonschema/1-0-2',
  'IGLU_NL_NS_ELEMENT_VIEW_JSONSCHEMA_4_0_2': 'iglu:nl.ns/element_view/jsonschema/4-0-2',
  'IGLU_NL_NS_ERROR_JSONSCHEMA_1_0_1': 'iglu:nl.ns/error/jsonschema/1-0-1',
  'IGLU_NL_NS_EXPANDABLE_CLICK_JSONSCHEMA_1_0_3': 'iglu:nl.ns/expandable_click/jsonschema/1-0-3',
  'IGLU_NL_NS_EXPERIMENT_VIEW_JSONSCHEMA_1_0_5': 'iglu:nl.ns/experiment_view/jsonschema/1-0-5',
  'IGLU_NL_NS_LINK_CLICK_JSONSCHEMA_1_0_1': 'iglu:nl.ns/link_click/jsonschema/1-0-1',
  'IGLU_NL_NS_LOGOUT_SUCCESS_JSONSCHEMA_1_0_1': 'iglu:nl.ns/logout_success/jsonschema/1-0-1',
  'IGLU_NL_NS_NBA_AUDIENCE_ADD_JSONSCHEMA_1_0_1': 'iglu:nl.ns/nba_audience_add/jsonschema/1-0-1',
  'IGLU_NL_NS_NBA_VIEW_JSONSCHEMA_1_0_3': 'iglu:nl.ns/nba_view/jsonschema/1-0-3',
  'IGLU_NL_NS_PAGE_VIEW_JSONSCHEMA_4_0_3': 'iglu:nl.ns/page_view/jsonschema/4-0-3',
  'IGLU_NL_NS_REISPLANNER_PLAN_TRIP_JSONSCHEMA_1_0_3': 'iglu:nl.ns/reisplanner_plan_trip/jsonschema/1-0-3',
  'IGLU_NL_NS_SEARCH_VIEW_RESULTS_JSONSCHEMA_2_0_3': 'iglu:nl.ns/search_view_results/jsonschema/2-0-3',
  'IGLU_NL_NS_SELECT_CLICK_JSONSCHEMA_1_0_2': 'iglu:nl.ns/select_click/jsonschema/1-0-2',
  'IGLU_NL_NS_SELECTABLE_CLICK_JSONSCHEMA_1_0_3': 'iglu:nl.ns/selectable_click/jsonschema/1-0-3',
  'IGLU_NL_NS_SERVER_EXPERIMENTS_JSONSCHEMA_1_0_1': 'iglu:nl.ns/server_experiments/jsonschema/1-0-1',
  'IGLU_NL_NS_SUBSCRIPTION_CANCEL_SELECT_JSONSCHEMA_1_0_1': 'iglu:nl.ns/subscription_cancel_select/jsonschema/1-0-1',
  'IGLU_NL_NS_SUBSCRIPTION_CHANGE_JSONSCHEMA_1_0_1': 'iglu:nl.ns/subscription_change/jsonschema/1-0-1',
  'IGLU_NL_NS_SUBSCRIPTION_CHANGE_SELECT_JSONSCHEMA_1_0_2': 'iglu:nl.ns/subscription_change_select/jsonschema/1-0-2',
  'IGLU_NL_NS_TOGGLE_CLICK_JSONSCHEMA_1_0_3': 'iglu:nl.ns/toggle_click/jsonschema/1-0-3',
  'IGLU_NL_NS_TOOLTIP_CLICK_JSONSCHEMA_1_0_4': 'iglu:nl.ns/tooltip_click/jsonschema/1-0-4',
  'IGLU_NL_NS_BUTTON_CLICK_JSONSCHEMA_2_0_6': 'iglu:nl.ns/button_click/jsonschema/2-0-6',
  'IGLU_NL_NS_APP_OS_UNSUPPORTED_JSONSCHEMA_1_0_0': 'iglu:nl.ns/app_os_unsupported/jsonschema/1-0-0',
  'IGLU_NL_NS_UNSUPPORTED_APP_VERSION_JSONSCHEMA_1_0_0': 'iglu:nl.ns/unsupported_app_version/jsonschema/1-0-0',
  'IGLU_NL_NS_UNSUPPORTED_OS_VERSION_JSONSCHEMA_1_0_0': 'iglu:nl.ns/unsupported_os_version/jsonschema/1-0-0',
  'IGLU_NL_NS_DEPRECATED_APP_VERSION_JSONSCHEMA_1_0_0': 'iglu:nl.ns/deprecated_app_version/jsonschema/1-0-0',
  'IGLU_NL_NS_ADD_PAYMENT_INFO_JSONSCHEMA_1_0_2': 'iglu:nl.ns/add_payment_info/jsonschema/1-0-2',
  'IGLU_NL_NS_ADD_SHIPPING_INFO_JSONSCHEMA_1_0_2': 'iglu:nl.ns/add_shipping_info/jsonschema/1-0-2',
  'IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_1_0_6': 'iglu:nl.ns/add_to_cart/jsonschema/1-0-6',
  'IGLU_NL_NS_BEGIN_CHECKOUT_JSONSCHEMA_1_0_2': 'iglu:nl.ns/begin_checkout/jsonschema/1-0-2',
  'IGLU_NL_NS_PURCHASE_JSONSCHEMA_2_0_7': 'iglu:nl.ns/purchase/jsonschema/2-0-7',
  'IGLU_NL_NS_PURCHASE_UNCONFIRMED_JSONSCHEMA_1_0_4': 'iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4',
  'IGLU_NL_NS_VIEW_ITEM_JSONSCHEMA_1_0_2': 'iglu:nl.ns/view_item/jsonschema/1-0-2',
  'IGLU_NL_NS_VIEW_ITEM_LIST_JSONSCHEMA_1_0_2': 'iglu:nl.ns/view_item_list/jsonschema/1-0-2',
  'IGLU_NL_NS_PURCHASE_INTENTION_CONTEXT_JSONSCHEMA_1_0_1': 'iglu:nl.ns/purchase_intention_context/jsonschema/1-0-1',
  'IGLU_NL_NS_JOURNEY_DETAIL_SAVE_TRIP_JSONSCHEMA_1_0_0': 'iglu:nl.ns/journey_detail_save_trip/jsonschema/1-0-0',
  'IGLU_NL_NS_JOURNEY_DETAIL_SET_NOTIFICATIONS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/journey_detail_set_notifications/jsonschema/1-0-0',
  'IGLU_NL_NS_SAVED_TRIPS_DELETE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/saved_trips_delete/jsonschema/1-0-0',
  'IGLU_NL_NS_SAVED_TRIPS_EXTRA_OPTIONS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/saved_trips_extra_options/jsonschema/1-0-0',
  'IGLU_NL_NS_SAVED_TRIPS_MODAL_CANCEL_JSONSCHEMA_1_0_0': 'iglu:nl.ns/saved_trips_modal_cancel/jsonschema/1-0-0',
  'IGLU_NL_NS_SAVED_TRIPS_MODAL_EXTRA_OPTIONS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/saved_trips_modal_extra_options/jsonschema/1-0-0',
  'IGLU_NL_NS_SAVED_TRIPS_MODAL_SAVE_NOTIFICATIONS_JSONSCHEMA_1_0_0': 'iglu:nl.ns/saved_trips_modal_save_notifications/jsonschema/1-0-0',
  'IGLU_NL_NS_SAVED_TRIPS_SAVE_CHANGES_JSONSCHEMA_1_0_0': 'iglu:nl.ns/saved_trips_save_changes/jsonschema/1-0-0',
  'IGLU_NL_NS_BOTTOM_BAR_SAVED_JSONSCHEMA_1_0_0': 'iglu:nl.ns/bottom_bar_saved/jsonschema/1-0-0',
  'IGLU_NL_NS_HOMEPAGE_SAVED_TRIPS_WIDGET_CLICK_JSONSCHEMA_1_0_0': 'iglu:nl.ns/homepage_saved_trips_widget_click/jsonschema/1-0-0',
  'IGLU_NL_NS_HOMEPAGE_SAVED_TRIPS_WIDGET_TO_SAVED_JSONSCHEMA_1_0_0': 'iglu:nl.ns/homepage_saved_trips_widget_to_saved/jsonschema/1-0-0',
  'IGLU_NL_NS_SELECT_ITEM_JSONSCHEMA_1_0_0': 'iglu:nl.ns/select_item/jsonschema/1-0-0',
  'IGLU_NL_NS_VIEW_ITEM_LIST_JSONSCHEMA_1_0_3': 'iglu:nl.ns/view_item_list/jsonschema/1-0-3',
  'IGLU_NL_NS_PAGE_CONTEXT_JSONSCHEMA_1_0_2': 'iglu:nl.ns/page_context/jsonschema/1-0-2',
  'IGLU_NL_NS_PAGE_VIEW_JSONSCHEMA_4_0_4': 'iglu:nl.ns/page_view/jsonschema/4-0-4',
  'IGLU_NL_NS_EXPERIMENTS_CONTEXT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/experiments_context/jsonschema/1-0-0',
  'IGLU_NL_NS_LOGIN_STATUS_CONTEXT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/login_status_context/jsonschema/1-0-0',
  'IGLU_NL_NS_PERSONALIZATION_CONTEXT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/personalization_context/jsonschema/1-0-0',
  'IGLU_NL_NS_PAGE_CONTEXT_JSONSCHEMA_1_0_3': 'iglu:nl.ns/page_context/jsonschema/1-0-3',
  'IGLU_NL_NS_BANNER_CLICK_JSONSCHEMA_1_0_4': 'iglu:nl.ns/banner_click/jsonschema/1-0-4',
  'IGLU_NL_NS_NBA_VIEW_JSONSCHEMA_1_0_4': 'iglu:nl.ns/nba_view/jsonschema/1-0-4',
  'IGLU_NL_NS_PURCHASE_JSONSCHEMA_2_0_8': 'iglu:nl.ns/purchase/jsonschema/2-0-8',
  'IGLU_NL_NS_CONSENT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/consent/jsonschema/1-0-0',
  'IGLU_NL_NS_SCROLL_CONTEXT_JSONSCHEMA_1_0_0': 'iglu:nl.ns/scroll_context/jsonschema/1-0-0',
  'IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1_0_8': 'iglu:nl.ns/screen_view/jsonschema/1-0-8',
  'IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1_0_9': 'iglu:nl.ns/screen_view/jsonschema/1-0-9',
  'IGLU_NL_NS_PURCHASE_NON_USABLE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/purchase_non_usable/jsonschema/1-0-0',
  'IGLU_NL_NS_EXPERIMENTS_INITIALIZED_JSONSCHEMA_1_0_0': 'iglu:nl.ns/experiments_initialized/jsonschema/1-0-0',
  'IGLU_NL_NS_EXPERIMENTS_JSONSCHEMA_1_0_1': 'iglu:nl.ns/experiments/jsonschema/1-0-1',
  'IGLU_NL_NS_EXPERIMENTS_JSONSCHEMA_1_0_2': 'iglu:nl.ns/experiments/jsonschema/1-0-2',
  'IGLU_NL_NS_GLOBAL_CONTEXTS_JSONSCHEMA_1_0_1': 'iglu:nl.ns/global_contexts/jsonschema/1-0-1',
  'IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1_1_0': 'iglu:nl.ns/screen_view/jsonschema/1-1-0',
  'IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1_0_10': 'iglu:nl.ns/screen_view/jsonschema/1-0-10',
  'IGLU_NL_NS_ADD_PAYMENT_INFO_JSONSCHEMA_1_0_3': 'iglu:nl.ns/add_payment_info/jsonschema/1-0-3',
  'IGLU_NL_NS_ADD_SHIPPING_INFO_JSONSCHEMA_1_0_3': 'iglu:nl.ns/add_shipping_info/jsonschema/1-0-3',
  'IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_1_0_7': 'iglu:nl.ns/add_to_cart/jsonschema/1-0-7',
  'IGLU_NL_NS_BEGIN_CHECKOUT_JSONSCHEMA_1_0_3': 'iglu:nl.ns/begin_checkout/jsonschema/1-0-3',
  'IGLU_NL_NS_KEUZEHULP_SUCCESS_JSONSCHEMA_1_0_2': 'iglu:nl.ns/keuzehulp_success/jsonschema/1-0-2',
  'IGLU_NL_NS_PURCHASE_JSONSCHEMA_2_0_9': 'iglu:nl.ns/purchase/jsonschema/2-0-9',
  'IGLU_NL_NS_PURCHASE_UNCONFIRMED_JSONSCHEMA_1_0_5': 'iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-5',
  'IGLU_NL_NS_VIEW_ITEM_JSONSCHEMA_1_0_3': 'iglu:nl.ns/view_item/jsonschema/1-0-3',
  'IGLU_NL_NS_VIEW_ITEM_LIST_JSONSCHEMA_1_0_4': 'iglu:nl.ns/view_item_list/jsonschema/1-0-4',
  'IGLU_NL_NS_REMOVE_FROM_CART_JSONSCHEMA_1_0_1': 'iglu:nl.ns/remove_from_cart/jsonschema/1-0-1',
  'IGLU_NL_NS_SELECT_ITEM_JSONSCHEMA_1_0_1': 'iglu:nl.ns/select_item/jsonschema/1-0-1',
  'IGLU_NL_NS_FORM_ERROR_JSONSCHEMA_1_0_1': 'iglu:nl.ns/form_error/jsonschema/1-0-1',
  'IGLU_NL_NS_FORM_START_JSONSCHEMA_1_0_1': 'iglu:nl.ns/form_start/jsonschema/1-0-1',
  'IGLU_NL_NS_FORM_SUBMIT_JSONSCHEMA_1_0_1': 'iglu:nl.ns/form_submit/jsonschema/1-0-1',
  'IGLU_NL_NS_PERSONALIZATION_CONTEXT_JSONSCHEMA_1_0_1': 'iglu:nl.ns/personalization_context/jsonschema/1-0-1',
  'IGLU_NL_NS_BEGIN_CHECKOUT_JSONSCHEMA_1_0_4': 'iglu:nl.ns/begin_checkout/jsonschema/1-0-4',
  'IGLU_NL_NS_FILE_DOWNLOAD_JSONSCHEMA_1_0_1': 'iglu:nl.ns/file_download/jsonschema/1-0-1',
  'IGLU_NL_NS_REISPLANNER_ERROR_JSONSCHEMA_1_0_1': 'iglu:nl.ns/reisplanner_error/jsonschema/1-0-1',
  'IGLU_NL_NS_CONSENT_JSONSCHEMA_1_0_2': 'iglu:nl.ns/consent/jsonschema/1-0-2',
  'IGLU_NL_NS_EXPERIMENTS_JSONSCHEMA_1_0_3': 'iglu:nl.ns/experiments/jsonschema/1-0-3',
  'IGLU_NL_NS_LOGIN_STATUS_CONTEXT_JSONSCHEMA_1_0_1': 'iglu:nl.ns/login_status_context/jsonschema/1-0-1',
  'IGLU_NL_NS_PAGE_CONTEXT_JSONSCHEMA_1_0_4': 'iglu:nl.ns/page_context/jsonschema/1-0-4',
  'IGLU_NL_NS_PURCHASE_INTENTION_CONTEXT_JSONSCHEMA_1_0_2': 'iglu:nl.ns/purchase_intention_context/jsonschema/1-0-2',
  'IGLU_NL_NS_SCREEN_CONTEXT_JSONSCHEMA_1_0_1': 'iglu:nl.ns/screen_context/jsonschema/1-0-1',
  'IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1_0_11': 'iglu:nl.ns/screen_view/jsonschema/1-0-11',
  'IGLU_NL_NS_EXPERIMENTS_SESSION_JSONSCHEMA_1_0_0': 'iglu:nl.ns/experiments_session/jsonschema/1-0-0',
  'IGLU_NL_NS_PURCHASE_JSONSCHEMA_2_0_10': 'iglu:nl.ns/purchase/jsonschema/2-0-10',
  'IGLU_NL_NS_PURCHASE_SERVER_SIDE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/purchase_server_side/jsonschema/1-0-0',
  'IGLU_NL_NS_ADD_PAYMENT_INFO_JSONSCHEMA_1_0_4': 'iglu:nl.ns/add_payment_info/jsonschema/1-0-4',
  'IGLU_NL_NS_ADD_SHIPPING_INFO_JSONSCHEMA_1_0_4': 'iglu:nl.ns/add_shipping_info/jsonschema/1-0-4',
  'IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_1_0_8': 'iglu:nl.ns/add_to_cart/jsonschema/1-0-8',
  'IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_2_0_0': 'iglu:nl.ns/add_to_cart/jsonschema/2-0-0',
  'IGLU_NL_NS_BEGIN_CHECKOUT_JSONSCHEMA_1_0_5': 'iglu:nl.ns/begin_checkout/jsonschema/1-0-5',
  'IGLU_NL_NS_KEUZEHULP_SUCCESS_JSONSCHEMA_1_0_1': 'iglu:nl.ns/keuzehulp_success/jsonschema/1-0-1',
  'IGLU_NL_NS_PURCHASE_JSONSCHEMA_2_0_11': 'iglu:nl.ns/purchase/jsonschema/2-0-11',
  'IGLU_NL_NS_PURCHASE_JSONSCHEMA_2_0_12': 'iglu:nl.ns/purchase/jsonschema/2-0-12',
  'IGLU_NL_NS_PURCHASE_UNCONFIRMED_JSONSCHEMA_1_0_6': 'iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-6',
  'IGLU_NL_NS_REMOVE_FROM_CART_JSONSCHEMA_1_0_2': 'iglu:nl.ns/remove_from_cart/jsonschema/1-0-2',
  'IGLU_NL_NS_SELECT_ITEM_JSONSCHEMA_1_0_3': 'iglu:nl.ns/select_item/jsonschema/1-0-3',
  'IGLU_NL_NS_VIEW_ITEM_JSONSCHEMA_1_0_4': 'iglu:nl.ns/view_item/jsonschema/1-0-4',
  'IGLU_NL_NS_VIEW_ITEM_LIST_JSONSCHEMA_1_0_5': 'iglu:nl.ns/view_item_list/jsonschema/1-0-5',
  'IGLU_NL_NS_ORDER_CHANGE_JSONSCHEMA_1_0_0': 'iglu:nl.ns/order_change/jsonschema/1-0-0',
  'IGLU_NL_NS_PURCHASE_UNCONFIRMED_JSONSCHEMA_1_0_7': 'iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-7',
  'IGLU_NL_NS_REMOVE_FROM_CART_JSONSCHEMA_1_0_3': 'iglu:nl.ns/remove_from_cart/jsonschema/1-0-3',
  'IGLU_NL_NS_ELEMENT_VIEW_JSONSCHEMA_4_0_3': 'iglu:nl.ns/element_view/jsonschema/4-0-3',
  'IGLU_NL_NS_EXTERNAL_REFERRER_JSONSCHEMA_1_0_0': 'iglu:nl.ns/external_referrer/jsonschema/1-0-0',
} as const;
export type SchemaType = typeof Schema;
export type SchemaValueType = SchemaType[keyof SchemaType];

export const Language = {
  'NL': 'nl',
  'EN': 'en',
} as const;
export type LanguageType = typeof Language;
export type LanguageValueType = LanguageType[keyof LanguageType];

export const NsShop = {
  'NS_BUSINESSCARD': 'ns_businesscard',
  'SPOORDEELWINKEL': 'spoordeelwinkel',
  'ABONNEMENTEN': 'abonnementen',
  'LOSSE_VERVOERSBEWIJZEN': 'losse_vervoersbewijzen',
  'LVB_KAARTJES': 'lvb_kaartjes',
  'LVB_APP': 'lvb_app',
  'NS_FLEX': 'ns-flex',
} as const;
export type NsShopType = typeof NsShop;
export type NsShopValueType = NsShopType[keyof NsShopType];

export const Currency = {
  'EUR': 'EUR',
} as const;
export type CurrencyType = typeof Currency;
export type CurrencyValueType = CurrencyType[keyof CurrencyType];

export const CampaignStatus = {
  'ACTIVE': 'active',
  'INACTIVE': 'inactive',
} as const;
export type CampaignStatusType = typeof CampaignStatus;
export type CampaignStatusValueType = CampaignStatusType[keyof CampaignStatusType];

export const PageType = {
  'SERVICE_PAGE': 'service_page',
  'HOME_PAGE': 'home_page',
  'CHECK_OUT_PAGE': 'check_out_page',
  'THANK_YOU_PAGE': 'thank_you_page',
  'PRODUCT_OVERVIEW_PAGE': 'product_overview_page',
  'PRODUCT_CATEGORY_PAGE': 'product_category_page',
  'PRODUCT_DETAIL_PAGE': 'product_detail_page',
  'PRODUCT_CONFIGURATION_PAGE': 'product_configuration_page',
  'CAMPAIGN_PAGE': 'campaign_page',
  'NOT_SET': 'not_set',
  'CONTENT_OVERVIEW_PAGE': 'content_overview_page',
  'CONTENT_ARTICLE_PAGE': 'content_article_page',
} as const;
export type PageTypeType = typeof PageType;
export type PageTypeValueType = PageTypeType[keyof PageTypeType];

export const WebsiteVersion = {
  'CONSUMENT': 'consument',
  'ZAKELIJK': 'zakelijk',
} as const;
export type WebsiteVersionType = typeof WebsiteVersion;
export type WebsiteVersionValueType = WebsiteVersionType[keyof WebsiteVersionType];

export const NsEnvironment = {
  'ACC': 'acc',
  'TEST': 'test',
  'PROD': 'prod',
  'TEST2': 'test2',
  'TEST3': 'test3',
  'TESTAUT': 'testaut',
  'TESTAUT2': 'testaut2',
  'TESTAUT3': 'testaut3',
  'DEV_LOCALHOST': 'dev-localhost',
  'UNITTEST': 'unittest',
} as const;
export type NsEnvironmentType = typeof NsEnvironment;
export type NsEnvironmentValueType = NsEnvironmentType[keyof NsEnvironmentType];

let sysPlatform: any;
let sysLanguage: any;
let sysNsEnvironment: any;
let sysDatalayerSource: any;

export function setSystemProperties(properties: {platform: PlatformValueType;
    language: LanguageValueType;
    nsEnvironment: NsEnvironmentValueType;
    datalayerSource: string}) {
  if (properties.platform !== null && properties.platform !== undefined) {
    sysPlatform = properties.platform;
  }
  if (properties.language !== null && properties.language !== undefined) {
    sysLanguage = properties.language;
  }
  if (properties.nsEnvironment !== null && properties.nsEnvironment !== undefined) {
    sysNsEnvironment = properties.nsEnvironment;
  }
  if (properties.datalayerSource !== null && properties.datalayerSource !== undefined) {
    sysDatalayerSource = properties.datalayerSource;
  }
}

let NsDataQueue: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {platform: PlatformValueType;
    language: LanguageValueType;
    nsEnvironment: NsEnvironmentValueType;
    datalayerSource: string},
    destinationOptions: any,
    NsDataQueueDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  setSystemProperties(systemProperties);
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    
    NsDataQueue = NsDataQueueDestination;
    if (__AVO_ENV__ === 'prod') {
      NsDataQueue && NsDataQueue.make && NsDataQueue.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      NsDataQueue && NsDataQueue.make && NsDataQueue.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for nsDataQueue. Head to destination settings in Avo to set a staging key.");
      NsDataQueue && NsDataQueue.make && NsDataQueue.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertExistingProductOptional(existingProduct: ExistingProduct[] | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (existingProduct !== undefined && existingProduct !== null) {
    messages = messages.concat(AvoAssert.assertList("GsMr_TucEDqV", "existing_product", existingProduct));
    existingProduct.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("GsMr_TucEDqV", "item at index " + index + " in existing_product", value));
    });
  }
  return messages;
}

function assertItems(items: Items[],
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList("Oavl4KfPHF3", "items", items));
  if (items !== null && items !== undefined && items.forEach) {
    items.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("Oavl4KfPHF3", "item at index " + index + " in items", value));
    });
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface ButtonClickProperties {
  buttonType: string | null | undefined;
  uniqueName: string;
  description: string | null | undefined;
  clickDestination: string | null | undefined;
  clickText: string | null | undefined;
  websiteSection: string | null | undefined;
  data: string | null | undefined;
}
/**
 * button_click: Fires when a button is clicked
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/FOzIm6uwh0q/trigger/NHJsKlxZV
 * 
 * @param properties the properties associatied with this event
 * @param properties.buttonType: Type of button that is clicked (reset, submit or button)
 * @param properties.uniqueName: Unique name / translations string for the element or event
 * @param properties.description: Description of the element or event
 * @param properties.clickDestination: Provide URL if the button navigates
 * @param properties.clickText: visible text which is clicked on / or label or element clicked (in case of nes-select for example)
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * @param properties.data: Extra information in string format
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/FOzIm6uwh0q}
 */
export function buttonClick(properties: ButtonClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.buttonType !== undefined && properties.buttonType !== null ?
    eventPropertiesArray.push({id: "oZ6ysVC6Ugt", name: "button_type", value: properties.buttonType}) :
    eventPropertiesArray.push({id: "oZ6ysVC6Ugt", name: "button_type", value: null});
  eventPropertiesArray.push({id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName});
  properties.description !== undefined && properties.description !== null ?
    eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: properties.description}) :
    eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: null});
  properties.clickDestination !== undefined && properties.clickDestination !== null ?
    eventPropertiesArray.push({id: "ZRYtNJDfVeyb", name: "click_destination", value: properties.clickDestination}) :
    eventPropertiesArray.push({id: "ZRYtNJDfVeyb", name: "click_destination", value: null});
  properties.clickText !== undefined && properties.clickText !== null ?
    eventPropertiesArray.push({id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText}) :
    eventPropertiesArray.push({id: "TFD27fnuBpN-", name: "click_text", value: null});
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  properties.data !== undefined && properties.data !== null ?
    eventPropertiesArray.push({id: "7HGUvDZb-Fax", name: "data", value: properties.data}) :
    eventPropertiesArray.push({id: "7HGUvDZb-Fax", name: "data", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/button_click/jsonschema/2-0-6"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "FOzIm6uwh0q", "5c9d250984dafa8031c6d4740842e644528e4d641bcdd2fa5ac9a4110b968736", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("button_click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("FOzIm6uwh0q", "button_click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("button_click", eventProperties, "FOzIm6uwh0q", "5c9d250984dafa8031c6d4740842e644528e4d641bcdd2fa5ac9a4110b968736");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("button_click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LinkClickProperties {
  newTab: boolean;
  externalLink: boolean;
  uniqueName: string;
  description: string;
  clickDestination: string;
  clickText: string;
  websiteSection: string | null | undefined;
}
/**
 * link_click: When a link is clicked
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/cbU-q4KjR86/trigger/0NaEFhD0K
 * 
 * @param properties the properties associatied with this event
 * @param properties.newTab: Link opens in new tab
 * @param properties.externalLink: Link links to an external domain.
 * @param properties.uniqueName: Unique name / translations string for the element or event
 * @param properties.description: Description of the element or event
 * @param properties.clickDestination: Provide URL if the button navigates
 * @param properties.clickText: visible text which is clicked on / or label or element clicked (in case of nes-select for example)
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/cbU-q4KjR86}
 */
export function linkClick(properties: LinkClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "nw5UW2_uvVj", name: "new_tab", value: properties.newTab});
  eventPropertiesArray.push({id: "DzZMn4cZBxR", name: "external_link", value: properties.externalLink});
  eventPropertiesArray.push({id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName});
  eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: properties.description});
  eventPropertiesArray.push({id: "ZRYtNJDfVeyb", name: "click_destination", value: properties.clickDestination});
  eventPropertiesArray.push({id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText});
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/link_click/jsonschema/1-0-1"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "cbU-q4KjR86", "d425e683e71f2cb1acef6505fbe4cce47c496470f8557d8cc2a930737a0d3b41", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("link_click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("cbU-q4KjR86", "link_click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("link_click", eventProperties, "cbU-q4KjR86", "d425e683e71f2cb1acef6505fbe4cce47c496470f8557d8cc2a930737a0d3b41");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("link_click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ErrorProperties {
  elementStructure: string;
  uniqueName: string;
  description: string;
  serverError: boolean;
  errorMessage: string[];
}
/**
 * error: Fires when the application encounters an error
 * 
 * @param properties the properties associatied with this event
 * @param properties.elementStructure: The page structure with a unique structure for the element that is viewed. For example: compare-modal|step-1. If used in combination with a interaction, provide the structure of the location on which the interaction takes place.
 * @param properties.uniqueName: Unique name / translations string for the element or event
 * @param properties.description: Description of the element or event
 * @param properties.serverError: The error is passed from a backend service
 * @param properties.errorMessage: What error message(s) does the user see? List of translation keys or strings.
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/dmwqgMxI_vz}
 */
export function error(properties: ErrorProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "FPhLne42GAA", name: "element_structure", value: properties.elementStructure});
  eventPropertiesArray.push({id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName});
  eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: properties.description});
  eventPropertiesArray.push({id: "Oevi6k4NhKu", name: "server_error", value: properties.serverError});
  eventPropertiesArray.push({id: "_UC5Zg5bYPN", name: "error_message", value: properties.errorMessage});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/error/jsonschema/1-0-1"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "dmwqgMxI_vz", "e8ae6cfd2a053636532da8b343cdd2e80a8d0b1665512ebea3d34d85e025a5d0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("error", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("dmwqgMxI_vz", "error", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("error", eventProperties, "dmwqgMxI_vz", "e8ae6cfd2a053636532da8b343cdd2e80a8d0b1665512ebea3d34d85e025a5d0");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("error", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CheckboxClickProperties {
  uniqueName: string;
  description: string;
  checked: boolean;
  clickText: string;
  websiteSection: string | null | undefined;
}
/**
 * checkbox_click: When a user interacts with a checkbox
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/u1opA49f2lE/trigger/qbN-Od0ou
 * 
 * @param properties the properties associatied with this event
 * @param properties.uniqueName: Unique name / translations string for the element or event
 * @param properties.description: Description of the element or event
 * @param properties.checked: Is the element selected of not?
 * @param properties.clickText: visible text which is clicked on / or label or element clicked (in case of nes-select for example)
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/u1opA49f2lE}
 */
export function checkboxClick(properties: CheckboxClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName});
  eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: properties.description});
  eventPropertiesArray.push({id: "rzoBfRsaz89", name: "checked", value: properties.checked});
  eventPropertiesArray.push({id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText});
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/checkbox_click/jsonschema/1-0-3"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "u1opA49f2lE", "2658e1584c7d7b0cec02b2d964196c51c9d4c9057ce4b9017c57ad34858435b2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("checkbox_click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("u1opA49f2lE", "checkbox_click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("checkbox_click", eventProperties, "u1opA49f2lE", "2658e1584c7d7b0cec02b2d964196c51c9d4c9057ce4b9017c57ad34858435b2");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("checkbox_click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BeginCheckoutProperties {
  currency: CurrencyValueType;
  coupon: string;
  value: number;
  items: Items[];
  nsShop: NsShopValueType;
  salesChannel: string | null | undefined;
}
/**
 * begin_checkout: Web: When you hit add to cart/go to cart button i.e. next step after product detail page
App: The step after the add_to_cart, when you configure the ticket
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: The currency of the purchase
 * @param properties.coupon: ONLY WEB | coupon-code or campaign id
 * @param properties.value: value of purhcased/added/removed item(s)
 * @param properties.items: item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
 * @param properties.nsShop: Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
 * @param properties.salesChannel: Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/YSfuMbF3uzA}
 */
export function beginCheckout(properties: BeginCheckoutProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GuYrcDncVS5", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon});
  eventPropertiesArray.push({id: "1WkP-6sA8x_5", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "Oavl4KfPHF3", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "coupon": value.coupon,
      "discount": value.discount,
      "index": value.index,
      "quantity": value.quantity,
      "price": value.price,
      "item_brand": value.itemBrand,
      "item_variant": value.itemVariant,
      "item_category": value.itemCategory,
      "travel_date": value.travelDate,
      "affiliation": value.affiliation,
      "item_category2": value.itemCategory2,
      "destination_station": value.destinationStation,
      "origin_station": value.originStation,
      "travel_class": value.travelClass,
      "travel_route": value.travelRoute,
      "intercity_direct": value.intercityDirect,
      "deur_tot_deur": value.deurTotDeur,
      "item_revenue": value.itemRevenue,
    }
  })});
  eventPropertiesArray.push({id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop});
  properties.salesChannel !== undefined && properties.salesChannel !== null ?
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel}) :
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/begin_checkout/jsonschema/1-0-5"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "YSfuMbF3uzA", "e0d20c35841867b6f0add8567999cb45ff8a624d28d320849a057284b5e5767e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("begin_checkout", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("YSfuMbF3uzA", "begin_checkout", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'begin_checkout': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("begin_checkout", eventProperties, "YSfuMbF3uzA", "e0d20c35841867b6f0add8567999cb45ff8a624d28d320849a057284b5e5767e");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("begin_checkout", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PurchaseProperties {
  currency: CurrencyValueType;
  transactionId: string;
  coupon: string | null | undefined;
  tax: number | null | undefined;
  value: number;
  items: Items[];
  nsShop: NsShopValueType;
  paymentType: PaymentTypeValueType[] | null | undefined;
  ticketClass: string | null | undefined;
  salesChannel: string | null | undefined;
  existingProduct: ExistingProduct[] | null | undefined;
}
/**
 * purchase: triggered when a purchase is verified (payed etc.) pref. server side, not dependend on a 'succes page' view.
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: The currency of the purchase
 * @param properties.transactionId: Transaction or Order ID of the order
 * @param properties.coupon: ONLY WEB | coupon-code or campaign id
 * @param properties.tax: € value of tax
 * @param properties.value: value of purhcased/added/removed item(s)
 * @param properties.items: item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
 * @param properties.nsShop: Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
 * @param properties.paymentType: payment type like iDeal, Creditcard etc
 * @param properties.ticketClass: class: first or second
 * @param properties.salesChannel: Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
 * @param properties.existingProduct: current product you up or downgrade (one):
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          item_category2: 'Abonnementen',
          item_variant: 'NS-Flex',
          price: 291.90,
          quantity: 1
        }]
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/AVPCdJ0ONj2}
 */
export function purchase(properties: PurchaseProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GuYrcDncVS5", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "SCki6fM2wea", name: "transaction_id", value: properties.transactionId});
  properties.coupon !== undefined && properties.coupon !== null ?
    eventPropertiesArray.push({id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon}) :
    eventPropertiesArray.push({id: "9Tv-BxH6jSI", name: "coupon", value: null});
  properties.tax !== undefined && properties.tax !== null ?
    eventPropertiesArray.push({id: "IBS3IO629xIC", name: "tax", value: properties.tax}) :
    eventPropertiesArray.push({id: "IBS3IO629xIC", name: "tax", value: null});
  eventPropertiesArray.push({id: "1WkP-6sA8x_5", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "Oavl4KfPHF3", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "coupon": value.coupon,
      "discount": value.discount,
      "index": value.index,
      "quantity": value.quantity,
      "price": value.price,
      "item_brand": value.itemBrand,
      "item_variant": value.itemVariant,
      "item_category": value.itemCategory,
      "travel_date": value.travelDate,
      "affiliation": value.affiliation,
      "item_category2": value.itemCategory2,
      "destination_station": value.destinationStation,
      "origin_station": value.originStation,
      "travel_class": value.travelClass,
      "travel_route": value.travelRoute,
      "intercity_direct": value.intercityDirect,
      "deur_tot_deur": value.deurTotDeur,
      "item_revenue": value.itemRevenue,
    }
  })});
  eventPropertiesArray.push({id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop});
  properties.paymentType !== undefined && properties.paymentType !== null ?
    eventPropertiesArray.push({id: "06ak1UmwgYlK", name: "payment_type", value: properties.paymentType}) :
    eventPropertiesArray.push({id: "06ak1UmwgYlK", name: "payment_type", value: null});
  properties.ticketClass !== undefined && properties.ticketClass !== null ?
    eventPropertiesArray.push({id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass}) :
    eventPropertiesArray.push({id: "OPP6AeYDy", name: "ticket_class", value: null});
  properties.salesChannel !== undefined && properties.salesChannel !== null ?
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel}) :
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: null});
  properties.existingProduct !== undefined && properties.existingProduct !== null ?
    eventPropertiesArray.push({id: "GsMr_TucEDqV", name: "existing_product", value: properties.existingProduct.map(function(value) { return {
        "item_id": value.itemId,
        "item_name": value.itemName,
        "quantity": value.quantity,
        "item_category": value.itemCategory,
        "item_category2": value.itemCategory2,
        "price": value.price,
        "item_brand": value.itemBrand,
        "item_variant": value.itemVariant,
      }
    })}) :
    eventPropertiesArray.push({id: "GsMr_TucEDqV", name: "existing_product", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/purchase/jsonschema/2-0-12"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    messages = messages.concat(assertExistingProductOptional(properties.existingProduct));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "AVPCdJ0ONj2", "1694c266bac7e7d200cfd95295b51096d8ad279f811fab871ec8b0217750cef4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("purchase", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("AVPCdJ0ONj2", "purchase", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'purchase': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("purchase", eventProperties, "AVPCdJ0ONj2", "1694c266bac7e7d200cfd95295b51096d8ad279f811fab871ec8b0217750cef4");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("purchase", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickProperties {
  clickClasses: string;
  clickType: string;
  clickDestination: string;
  clickText: string;
  data: string | null | undefined;
  websiteSection: string | null | undefined;
  clickId1: string | null | undefined;
}
/**
 * click: click on links buttons etc
 * 
 * @param properties the properties associatied with this event
 * @param properties.clickClasses: no description
 * @param properties.clickType: e.g. 'button', 'checkbox', 'text_link'
 * @param properties.clickDestination: Provide URL if the button navigates
 * @param properties.clickText: visible text which is clicked on / or label or element clicked (in case of nes-select for example)
 * @param properties.data: Extra information in string format
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * @param properties.clickId1: The HTML id attribute for an outbound link or file download
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/1s4XEWLbFQ9}
 */
export function click(properties: ClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "K5J4L8efdGgl", name: "click_classes", value: properties.clickClasses});
  eventPropertiesArray.push({id: "BxxFgWL7KfAD", name: "click_type", value: properties.clickType});
  eventPropertiesArray.push({id: "ZRYtNJDfVeyb", name: "click_destination", value: properties.clickDestination});
  eventPropertiesArray.push({id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText});
  properties.data !== undefined && properties.data !== null ?
    eventPropertiesArray.push({id: "7HGUvDZb-Fax", name: "data", value: properties.data}) :
    eventPropertiesArray.push({id: "7HGUvDZb-Fax", name: "data", value: null});
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  properties.clickId1 !== undefined && properties.clickId1 !== null ?
    eventPropertiesArray.push({id: "HolZTTkkioUB", name: "click_id", value: properties.clickId1}) :
    eventPropertiesArray.push({id: "HolZTTkkioUB", name: "click_id", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/click/jsonschema/1-0-2"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1s4XEWLbFQ9", "75fbef18948e524e864d3e0e0683012c61356e1193fe2a8ad0f1f998fdcbb8ef", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1s4XEWLbFQ9", "click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("click", eventProperties, "1s4XEWLbFQ9", "75fbef18948e524e864d3e0e0683012c61356e1193fe2a8ad0f1f998fdcbb8ef");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FormStartProperties {
  formName: string;
  formId1: string;
}
/**
 * form_start: triggers on first click in the form
 * 
 * @param properties the properties associatied with this event
 * @param properties.formName: Name parameter from the <form> tag
 * @param properties.formId1: ID parameter of the form tag
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/mBzV6jmUM7H}
 */
export function formStart(properties: FormStartProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName});
  eventPropertiesArray.push({id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/form_start/jsonschema/1-0-1"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "mBzV6jmUM7H", "34808c9352d4fa0c3d6ac8bb3906d85a851412f36c1d370b5b135b9487511cb7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("form_start", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("mBzV6jmUM7H", "form_start", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("form_start", eventProperties, "mBzV6jmUM7H", "34808c9352d4fa0c3d6ac8bb3906d85a851412f36c1d370b5b135b9487511cb7");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("form_start", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FormSubmitProperties {
  formId1: string;
  formDestination: string;
  permissions: string[] | null | undefined;
  clickText: string;
  formName: string;
}
/**
 * form_submit: triggers after submitting the form (after field validation)
 * 
 * @param properties the properties associatied with this event
 * @param properties.formId1: ID parameter of the form tag
 * @param properties.formDestination: Full URL of the redirect after the form submit
 * @param properties.permissions: Array with modified permissions and status
[
  {
    'type':'Commercieel',
    'status':'true',
  },
  {
    'type':'Reisgegevens delen',
    'status':'false',
  },
]
 * @param properties.clickText: visible text which is clicked on / or label or element clicked (in case of nes-select for example)
 * @param properties.formName: Name parameter from the <form> tag
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/DBkD3D8Uq_u}
 */
export function formSubmit(properties: FormSubmitProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1});
  eventPropertiesArray.push({id: "83KZlBXgHnFi", name: "form_destination", value: properties.formDestination});
  properties.permissions !== undefined && properties.permissions !== null ?
    eventPropertiesArray.push({id: "b6ebejYlEx2Y", name: "permissions", value: properties.permissions}) :
    eventPropertiesArray.push({id: "b6ebejYlEx2Y", name: "permissions", value: null});
  eventPropertiesArray.push({id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText});
  eventPropertiesArray.push({id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/form_submit/jsonschema/1-0-1"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "DBkD3D8Uq_u", "65baa8a768519b64fe54d4ff950448f0c0ef6f6b461ec0f1b3821ce7c4870d4c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("form_submit", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("DBkD3D8Uq_u", "form_submit", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("form_submit", eventProperties, "DBkD3D8Uq_u", "65baa8a768519b64fe54d4ff950448f0c0ef6f6b461ec0f1b3821ce7c4870d4c");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("form_submit", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FormErrorProperties {
  formName: string;
  formId1: string;
  errorMessage: string[];
}
/**
 * form_error: triggers after field validation
 * 
 * @param properties the properties associatied with this event
 * @param properties.formName: Name parameter from the <form> tag
 * @param properties.formId1: ID parameter of the form tag
 * @param properties.errorMessage: What error message(s) does the user see? List of translation keys or strings.
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/xduE82bRW-m}
 */
export function formError(properties: FormErrorProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName});
  eventPropertiesArray.push({id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1});
  eventPropertiesArray.push({id: "_UC5Zg5bYPN", name: "error_message", value: properties.errorMessage});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/form_error/jsonschema/1-0-1"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "xduE82bRW-m", "46fc80b7a932b76d117c9298e702ae6260cc5329431c12356496c5c7f3b7e443", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("form_error", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("xduE82bRW-m", "form_error", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("form_error", eventProperties, "xduE82bRW-m", "46fc80b7a932b76d117c9298e702ae6260cc5329431c12356496c5c7f3b7e443");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("form_error", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewItemProperties {
  value: number;
  items: Items[];
  nsShop: NsShopValueType;
  salesChannel: string | null | undefined;
}
/**
 * view_item: Triggers when the product detail page is viewed
 * 
 * @param properties the properties associatied with this event
 * @param properties.value: value of purhcased/added/removed item(s)
 * @param properties.items: item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
 * @param properties.nsShop: Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
 * @param properties.salesChannel: Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/jwnzAKOyDYr}
 */
export function viewItem(properties: ViewItemProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "1WkP-6sA8x_5", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "Oavl4KfPHF3", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "coupon": value.coupon,
      "discount": value.discount,
      "index": value.index,
      "quantity": value.quantity,
      "price": value.price,
      "item_brand": value.itemBrand,
      "item_variant": value.itemVariant,
      "item_category": value.itemCategory,
      "travel_date": value.travelDate,
      "affiliation": value.affiliation,
      "item_category2": value.itemCategory2,
      "destination_station": value.destinationStation,
      "origin_station": value.originStation,
      "travel_class": value.travelClass,
      "travel_route": value.travelRoute,
      "intercity_direct": value.intercityDirect,
      "deur_tot_deur": value.deurTotDeur,
      "item_revenue": value.itemRevenue,
    }
  })});
  eventPropertiesArray.push({id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop});
  properties.salesChannel !== undefined && properties.salesChannel !== null ?
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel}) :
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: null});
  eventPropertiesArray.push({id: "GuYrcDncVS5", name: "currency", value: "EUR"});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/view_item/jsonschema/1-0-4"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "jwnzAKOyDYr", "06423f16ba0602ecb92fd39b1035d04b527e17da5fc7e4f7b1597904e7fb2ca7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("view_item", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("jwnzAKOyDYr", "view_item", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'view_item': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_item", eventProperties, "jwnzAKOyDYr", "06423f16ba0602ecb92fd39b1035d04b527e17da5fc7e4f7b1597904e7fb2ca7");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("view_item", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface KeuzehulpClickProperties {
  question: string;
  answer: string;
  websiteVersion: WebsiteVersionValueType;
}
/**
 * keuzehulp_click: Triggers when a user clicks on a given choice in the keuzehulp
 * 
 * @param properties the properties associatied with this event
 * @param properties.question: question
 * @param properties.answer: answer
 * @param properties.websiteVersion: Consument of zakelijk
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/zxrhsEtLq6G}
 */
export function keuzehulpClick(properties: KeuzehulpClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "7f5ty_nULaWo", name: "question", value: properties.question});
  eventPropertiesArray.push({id: "F4RDcFwudL0_", name: "answer", value: properties.answer});
  eventPropertiesArray.push({id: "l4YWQepFGqt9", name: "website_version", value: properties.websiteVersion});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "zxrhsEtLq6G", "4656326cddb626985a4aaafcbd2a56cd1517f910f5e1bedced61783e8e5f856d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("keuzehulp_click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("zxrhsEtLq6G", "keuzehulp_click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("keuzehulp_click", eventProperties, "zxrhsEtLq6G", "4656326cddb626985a4aaafcbd2a56cd1517f910f5e1bedced61783e8e5f856d");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("keuzehulp_click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface KeuzehulpSuccessProperties {
  items: Items[];
  websiteVersion: WebsiteVersionValueType;
}
/**
 * keuzehulp_success: Triggers on show page advice keuzehulp
 * 
 * @param properties the properties associatied with this event
 * @param properties.items: item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
 * @param properties.websiteVersion: Consument of zakelijk
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/oxnl9fXxacs}
 */
export function keuzehulpSuccess(properties: KeuzehulpSuccessProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Oavl4KfPHF3", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "coupon": value.coupon,
      "discount": value.discount,
      "index": value.index,
      "quantity": value.quantity,
      "price": value.price,
      "item_brand": value.itemBrand,
      "item_variant": value.itemVariant,
      "item_category": value.itemCategory,
      "travel_date": value.travelDate,
      "affiliation": value.affiliation,
      "item_category2": value.itemCategory2,
      "destination_station": value.destinationStation,
      "origin_station": value.originStation,
      "travel_class": value.travelClass,
      "travel_route": value.travelRoute,
      "intercity_direct": value.intercityDirect,
      "deur_tot_deur": value.deurTotDeur,
      "item_revenue": value.itemRevenue,
    }
  })});
  eventPropertiesArray.push({id: "l4YWQepFGqt9", name: "website_version", value: properties.websiteVersion});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-1"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "oxnl9fXxacs", "6e00e32f81b591eb94cccc974a1462c501d1b2731340d335d34b8024613ffa62", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("keuzehulp_success", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("oxnl9fXxacs", "keuzehulp_success", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'keuzehulp_success': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("keuzehulp_success", eventProperties, "oxnl9fXxacs", "6e00e32f81b591eb94cccc974a1462c501d1b2731340d335d34b8024613ffa62");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("keuzehulp_success", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LeadGenerateProperties {
  formId1: string;
  formName: string;
}
/**
 * lead_generate: when succesfull leadform send by user
 * 
 * @param properties the properties associatied with this event
 * @param properties.formId1: ID parameter of the form tag
 * @param properties.formName: Name parameter from the <form> tag
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/ubmAH73Pvjx}
 */
export function leadGenerate(properties: LeadGenerateProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1});
  eventPropertiesArray.push({id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/lead_generate/jsonschema/1-0-0"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ubmAH73Pvjx", "4690af86e696ca853cf4c9be95250ede58c282350751a068de541f882d6ce571", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("lead_generate", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ubmAH73Pvjx", "lead_generate", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lead_generate", eventProperties, "ubmAH73Pvjx", "4690af86e696ca853cf4c9be95250ede58c282350751a068de541f882d6ce571");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("lead_generate", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PageViewProperties {
  pagePath: string;
  pageStructure: string;
  pageType: PageTypeValueType;
  pageTitle: string;
  virtual: boolean | null | undefined;
  campaignStatus: CampaignStatusValueType | null | undefined;
  nsShop: NsShopValueType | null | undefined;
}
/**
 * page_view: page views including Angular dynamic page views & WAHS 'pages'
 * 
 * @param properties the properties associatied with this event
 * @param properties.pagePath: web only
 * @param properties.pageStructure: Unique page structure with a unique structure for the page that is viewed. For example: ns.nl|ns-flex|abonnementen. If used in combination with a interaction, provide the structure of the location on which the interaction takes place.
 * @param properties.pageType: category type of the page: service_page, thank_you_page,check_out_page
 * @param properties.pageTitle: title of the webpage
 * @param properties.virtual: virtual page
 * @param properties.campaignStatus: The status of the campaign if page_type is 
 * @param properties.nsShop: Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/U6jhs_8eU}
 */
export function pageView(properties: PageViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "PgQL3oYhqcEj", name: "page_path", value: properties.pagePath});
  eventPropertiesArray.push({id: "z__awEy565g", name: "page_structure", value: properties.pageStructure});
  eventPropertiesArray.push({id: "juLwL7wdryz", name: "page_type", value: properties.pageType});
  eventPropertiesArray.push({id: "HrAYDiO719kk", name: "page_title", value: properties.pageTitle});
  properties.virtual !== undefined && properties.virtual !== null ?
    eventPropertiesArray.push({id: "_3Sy5DLQHqRD", name: "virtual", value: properties.virtual}) :
    eventPropertiesArray.push({id: "_3Sy5DLQHqRD", name: "virtual", value: null});
  properties.campaignStatus !== undefined && properties.campaignStatus !== null ?
    eventPropertiesArray.push({id: "fW6NdHL5V", name: "campaign_status", value: properties.campaignStatus}) :
    eventPropertiesArray.push({id: "fW6NdHL5V", name: "campaign_status", value: null});
  properties.nsShop !== undefined && properties.nsShop !== null ?
    eventPropertiesArray.push({id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop}) :
    eventPropertiesArray.push({id: "BImlhIesBPhx", name: "ns_shop", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/page_view/jsonschema/4-0-4"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "U6jhs_8eU", "82dc547db997f18ffdb1e394b3ab2fc281bf6091e2c3bbbcde97d0417e2c39af", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("page_view", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("U6jhs_8eU", "page_view", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("page_view", eventProperties, "U6jhs_8eU", "82dc547db997f18ffdb1e394b3ab2fc281bf6091e2c3bbbcde97d0417e2c39af");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("page_view", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AddToCartProperties {
  currency: CurrencyValueType;
  value: number;
  items: Items[];
  nsShop: NsShopValueType;
}
/**
 * add_to_cart: App: When you hit add to cart button in multiple buying flows
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: The currency of the purchase
 * @param properties.value: value of purhcased/added/removed item(s)
 * @param properties.items: item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
 * @param properties.nsShop: Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/XIShibtSw}
 */
export function addToCart(properties: AddToCartProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GuYrcDncVS5", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "1WkP-6sA8x_5", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "Oavl4KfPHF3", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "coupon": value.coupon,
      "discount": value.discount,
      "index": value.index,
      "quantity": value.quantity,
      "price": value.price,
      "item_brand": value.itemBrand,
      "item_variant": value.itemVariant,
      "item_category": value.itemCategory,
      "travel_date": value.travelDate,
      "affiliation": value.affiliation,
      "item_category2": value.itemCategory2,
      "destination_station": value.destinationStation,
      "origin_station": value.originStation,
      "travel_class": value.travelClass,
      "travel_route": value.travelRoute,
      "intercity_direct": value.intercityDirect,
      "deur_tot_deur": value.deurTotDeur,
      "item_revenue": value.itemRevenue,
    }
  })});
  eventPropertiesArray.push({id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/add_to_cart/jsonschema/2-0-0"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "XIShibtSw", "b3f5567db96d36dadf2bf9effc6061ba407821948cba78e4a0251cc5f72073c7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("add_to_cart", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("XIShibtSw", "add_to_cart", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'add_to_cart': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_to_cart", eventProperties, "XIShibtSw", "b3f5567db96d36dadf2bf9effc6061ba407821948cba78e4a0251cc5f72073c7");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("add_to_cart", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RemoveFromCartProperties {
  currency: CurrencyValueType;
  value: number;
  items: Items[];
  nsShop: NsShopValueType;
  websiteSection: string | null | undefined;
  existingProduct: ExistingProduct[] | null | undefined;
}
/**
 * remove_from_cart: When a product is removed from the cart
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: The currency of the purchase
 * @param properties.value: value of purhcased/added/removed item(s)
 * @param properties.items: item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
 * @param properties.nsShop: Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * @param properties.existingProduct: current product you up or downgrade (one):
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          item_category2: 'Abonnementen',
          item_variant: 'NS-Flex',
          price: 291.90,
          quantity: 1
        }]
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/FnwydILgs}
 */
export function removeFromCart(properties: RemoveFromCartProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GuYrcDncVS5", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "1WkP-6sA8x_5", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "Oavl4KfPHF3", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "coupon": value.coupon,
      "discount": value.discount,
      "index": value.index,
      "quantity": value.quantity,
      "price": value.price,
      "item_brand": value.itemBrand,
      "item_variant": value.itemVariant,
      "item_category": value.itemCategory,
      "travel_date": value.travelDate,
      "affiliation": value.affiliation,
      "item_category2": value.itemCategory2,
      "destination_station": value.destinationStation,
      "origin_station": value.originStation,
      "travel_class": value.travelClass,
      "travel_route": value.travelRoute,
      "intercity_direct": value.intercityDirect,
      "deur_tot_deur": value.deurTotDeur,
      "item_revenue": value.itemRevenue,
    }
  })});
  eventPropertiesArray.push({id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop});
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  properties.existingProduct !== undefined && properties.existingProduct !== null ?
    eventPropertiesArray.push({id: "GsMr_TucEDqV", name: "existing_product", value: properties.existingProduct.map(function(value) { return {
        "item_id": value.itemId,
        "item_name": value.itemName,
        "quantity": value.quantity,
        "item_category": value.itemCategory,
        "item_category2": value.itemCategory2,
        "price": value.price,
        "item_brand": value.itemBrand,
        "item_variant": value.itemVariant,
      }
    })}) :
    eventPropertiesArray.push({id: "GsMr_TucEDqV", name: "existing_product", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/remove_from_cart/jsonschema/1-0-3"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    messages = messages.concat(assertExistingProductOptional(properties.existingProduct));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "FnwydILgs", "7ac089cb0f8162e36defbc25ad476f1101aaeac15f2f61f3dde4782d476c3d58", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("remove_from_cart", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("FnwydILgs", "remove_from_cart", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'remove_from_cart': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("remove_from_cart", eventProperties, "FnwydILgs", "7ac089cb0f8162e36defbc25ad476f1101aaeac15f2f61f3dde4782d476c3d58");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("remove_from_cart", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DatepickerClickProperties {
  selectedDate: string;
  websiteSection: string | null | undefined;
  uniqueName: string;
  description: string;
}
/**
 * datepicker_click: Click in de (nes) datapicker (selecting date)
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/msKAEF5r8m/trigger/jTSXtyBva
 * 
 * @param properties the properties associatied with this event
 * @param properties.selectedDate: Date as string in 'DD-MM-YYYY' format
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * @param properties.uniqueName: Unique name / translations string for the element or event
 * @param properties.description: Description of the element or event
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/msKAEF5r8m}
 */
export function datepickerClick(properties: DatepickerClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "cT6ai5_Dk", name: "selected_date", value: properties.selectedDate});
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  eventPropertiesArray.push({id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName});
  eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: properties.description});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/datepicker_click/jsonschema/1-0-3"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "msKAEF5r8m", "e73bd70e9ccafa7c53870342f437a3bd3d51aa46d42fbd28bd49ddc20f665335", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("datepicker_click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("msKAEF5r8m", "datepicker_click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("datepicker_click", eventProperties, "msKAEF5r8m", "e73bd70e9ccafa7c53870342f437a3bd3d51aa46d42fbd28bd49ddc20f665335");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("datepicker_click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SelectClickProperties {
  websiteSection: string | null | undefined;
  description: string;
  uniqueName: string;
  clickText: string;
  optionAmount: number | null | undefined;
  selectedOption: string;
  optionList: string[];
}
/**
 * select_click: Click event when user selects an option in a select element
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/GnxZUuAXuv/trigger/9RpwarP4T
 * 
 * @param properties the properties associatied with this event
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * @param properties.description: Description of the element or event
 * @param properties.uniqueName: Unique name / translations string for the element or event
 * @param properties.clickText: visible text which is clicked on / or label or element clicked (in case of nes-select for example)
 * @param properties.optionAmount: Amount of options that user can select from. 
 * @param properties.selectedOption: Label or value of option that is selected
 * @param properties.optionList: Optional list of items that the user see as select options
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/GnxZUuAXuv}
 */
export function selectClick(properties: SelectClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: properties.description});
  eventPropertiesArray.push({id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName});
  eventPropertiesArray.push({id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText});
  properties.optionAmount !== undefined && properties.optionAmount !== null ?
    eventPropertiesArray.push({id: "gyvKCwS5E", name: "option_amount", value: properties.optionAmount}) :
    eventPropertiesArray.push({id: "gyvKCwS5E", name: "option_amount", value: null});
  eventPropertiesArray.push({id: "2_Kyx49Pj", name: "selected_option", value: properties.selectedOption});
  eventPropertiesArray.push({id: "MJqw4kh96", name: "option_list", value: properties.optionList});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/select_click/jsonschema/1-0-2"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "GnxZUuAXuv", "85f4254a827964c76f5340cd12bb240b0d5db6af4a65f9a9eba2296a0b0f6ba6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("select_click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("GnxZUuAXuv", "select_click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("select_click", eventProperties, "GnxZUuAXuv", "85f4254a827964c76f5340cd12bb240b0d5db6af4a65f9a9eba2296a0b0f6ba6");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("select_click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SelectableClickProperties {
  uniqueName: string;
  description: string;
  websiteSection: string | null | undefined;
  clickText: string;
  optionList: string[] | null | undefined;
  selectedOption: string;
  optionAmount: number | null | undefined;
}
/**
 * selectable_click: Click on (nes) selectable element
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/MLjZq2fxPU/trigger/fCE1oL9DS
 * 2. 
 * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/MLjZq2fxPU/trigger/_PJvkmUUu
 * 
 * @param properties the properties associatied with this event
 * @param properties.uniqueName: Unique name / translations string for the element or event
 * @param properties.description: Description of the element or event
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * @param properties.clickText: visible text which is clicked on / or label or element clicked (in case of nes-select for example)
 * @param properties.optionList: Optional list of items that the user see as select options
 * @param properties.selectedOption: Label or value of option that is selected
 * @param properties.optionAmount: Amount of options that user can select from. 
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/MLjZq2fxPU}
 */
export function selectableClick(properties: SelectableClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName});
  eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: properties.description});
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  eventPropertiesArray.push({id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText});
  properties.optionList !== undefined && properties.optionList !== null ?
    eventPropertiesArray.push({id: "MJqw4kh96", name: "option_list", value: properties.optionList}) :
    eventPropertiesArray.push({id: "MJqw4kh96", name: "option_list", value: null});
  eventPropertiesArray.push({id: "2_Kyx49Pj", name: "selected_option", value: properties.selectedOption});
  properties.optionAmount !== undefined && properties.optionAmount !== null ?
    eventPropertiesArray.push({id: "gyvKCwS5E", name: "option_amount", value: properties.optionAmount}) :
    eventPropertiesArray.push({id: "gyvKCwS5E", name: "option_amount", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/selectable_click/jsonschema/1-0-3"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MLjZq2fxPU", "c2b79ebdb96bfe2d62e9fac2d3d12d06f87f986d8438b6e039b4d86bba29ba38", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("selectable_click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MLjZq2fxPU", "selectable_click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("selectable_click", eventProperties, "MLjZq2fxPU", "c2b79ebdb96bfe2d62e9fac2d3d12d06f87f986d8438b6e039b4d86bba29ba38");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("selectable_click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ExpandableClickProperties {
  clickText: string;
  websiteSection: string | null | undefined;
  uniqueName: string;
  description: string;
  opened: boolean;
}
/**
 * expandable_click: Click on (nes) expandable element
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/VDgWpmWo1M/trigger/qednrkkmG
 * 2. 
 * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/VDgWpmWo1M/trigger/V_TcP3S_J
 * 
 * @param properties the properties associatied with this event
 * @param properties.clickText: visible text which is clicked on / or label or element clicked (in case of nes-select for example)
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * @param properties.uniqueName: Unique name / translations string for the element or event
 * @param properties.description: Description of the element or event
 * @param properties.opened: Does the user opens the element?
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/VDgWpmWo1M}
 */
export function expandableClick(properties: ExpandableClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText});
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  eventPropertiesArray.push({id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName});
  eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: properties.description});
  eventPropertiesArray.push({id: "5r8JteLxZ", name: "opened", value: properties.opened});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/expandable_click/jsonschema/1-0-3"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "VDgWpmWo1M", "bd718bdcbb7822a0ec5e4db78697dfae04441c8891654f2414f2360d20b20675", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("expandable_click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("VDgWpmWo1M", "expandable_click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("expandable_click", eventProperties, "VDgWpmWo1M", "bd718bdcbb7822a0ec5e4db78697dfae04441c8891654f2414f2360d20b20675");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("expandable_click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ToggleClickProperties {
  clickText: string;
  uniqueName: string;
  description: string;
  websiteSection: string | null | undefined;
  checked: boolean;
}
/**
 * toggle_click: Click on (nes) toggle element
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/BUoGWMzQE/trigger/wL9AzUGxp
 * 
 * @param properties the properties associatied with this event
 * @param properties.clickText: visible text which is clicked on / or label or element clicked (in case of nes-select for example)
 * @param properties.uniqueName: Unique name / translations string for the element or event
 * @param properties.description: Description of the element or event
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * @param properties.checked: Is the element selected of not?
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/BUoGWMzQE}
 */
export function toggleClick(properties: ToggleClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText});
  eventPropertiesArray.push({id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName});
  eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: properties.description});
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  eventPropertiesArray.push({id: "rzoBfRsaz89", name: "checked", value: properties.checked});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/toggle_click/jsonschema/1-0-3"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "BUoGWMzQE", "47c7c2a0bed919023fadba9049173c7e98d154ae6eaad791ed5cd88e9481e398", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("toggle_click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("BUoGWMzQE", "toggle_click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("toggle_click", eventProperties, "BUoGWMzQE", "47c7c2a0bed919023fadba9049173c7e98d154ae6eaad791ed5cd88e9481e398");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("toggle_click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewItemListProperties {
  value: number;
  items: Items[];
  itemListId: string | null | undefined;
  itemListName: string | null | undefined;
  nsShop: NsShopValueType;
  salesChannel: string | null | undefined;
}
/**
 * view_item_list: Triggers when the product detail page is viewed
 * 
 * @param properties the properties associatied with this event
 * @param properties.value: value of purhcased/added/removed item(s)
 * @param properties.items: item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
 * @param properties.itemListId: id of the list viewed
 * @param properties.itemListName: The name of the list in which the item was presented to the user
 * @param properties.nsShop: Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
 * @param properties.salesChannel: Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/deRK33OE7}
 */
export function viewItemList(properties: ViewItemListProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "1WkP-6sA8x_5", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "Oavl4KfPHF3", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "coupon": value.coupon,
      "discount": value.discount,
      "index": value.index,
      "quantity": value.quantity,
      "price": value.price,
      "item_brand": value.itemBrand,
      "item_variant": value.itemVariant,
      "item_category": value.itemCategory,
      "travel_date": value.travelDate,
      "affiliation": value.affiliation,
      "item_category2": value.itemCategory2,
      "destination_station": value.destinationStation,
      "origin_station": value.originStation,
      "travel_class": value.travelClass,
      "travel_route": value.travelRoute,
      "intercity_direct": value.intercityDirect,
      "deur_tot_deur": value.deurTotDeur,
      "item_revenue": value.itemRevenue,
    }
  })});
  properties.itemListId !== undefined && properties.itemListId !== null ?
    eventPropertiesArray.push({id: "qAs6FFElba8q", name: "item_list_id", value: properties.itemListId}) :
    eventPropertiesArray.push({id: "qAs6FFElba8q", name: "item_list_id", value: null});
  properties.itemListName !== undefined && properties.itemListName !== null ?
    eventPropertiesArray.push({id: "LydSjYynFBlR", name: "item_list_name", value: properties.itemListName}) :
    eventPropertiesArray.push({id: "LydSjYynFBlR", name: "item_list_name", value: null});
  eventPropertiesArray.push({id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop});
  properties.salesChannel !== undefined && properties.salesChannel !== null ?
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel}) :
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: null});
  eventPropertiesArray.push({id: "GuYrcDncVS5", name: "currency", value: "EUR"});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/view_item_list/jsonschema/1-0-5"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "deRK33OE7", "8abaecfbb73c51d7b948f94183749e696d966166a53c5d96f40ccbe3d7161f72", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("view_item_list", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("deRK33OE7", "view_item_list", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'view_item_list': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_item_list", eventProperties, "deRK33OE7", "8abaecfbb73c51d7b948f94183749e696d966166a53c5d96f40ccbe3d7161f72");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("view_item_list", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AddShippingInfoProperties {
  currency: CurrencyValueType;
  value: number;
  items: Items[];
  nsShop: NsShopValueType;
  salesChannel: string | null | undefined;
}
/**
 * add_shipping_info: Web: The step before the last step
App: Confirms name and e-mail adress
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: The currency of the purchase
 * @param properties.value: value of purhcased/added/removed item(s)
 * @param properties.items: item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
 * @param properties.nsShop: Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
 * @param properties.salesChannel: Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/mkKucON6P}
 */
export function addShippingInfo(properties: AddShippingInfoProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GuYrcDncVS5", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "1WkP-6sA8x_5", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "Oavl4KfPHF3", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "coupon": value.coupon,
      "discount": value.discount,
      "index": value.index,
      "quantity": value.quantity,
      "price": value.price,
      "item_brand": value.itemBrand,
      "item_variant": value.itemVariant,
      "item_category": value.itemCategory,
      "travel_date": value.travelDate,
      "affiliation": value.affiliation,
      "item_category2": value.itemCategory2,
      "destination_station": value.destinationStation,
      "origin_station": value.originStation,
      "travel_class": value.travelClass,
      "travel_route": value.travelRoute,
      "intercity_direct": value.intercityDirect,
      "deur_tot_deur": value.deurTotDeur,
      "item_revenue": value.itemRevenue,
    }
  })});
  eventPropertiesArray.push({id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop});
  properties.salesChannel !== undefined && properties.salesChannel !== null ?
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel}) :
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/add_shipping_info/jsonschema/1-0-4"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "mkKucON6P", "2b2dde3bcbaf7bd0007d0f42ecacc247e1b60c8636252fd7450739202b170bf2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("add_shipping_info", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("mkKucON6P", "add_shipping_info", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'add_shipping_info': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_shipping_info", eventProperties, "mkKucON6P", "2b2dde3bcbaf7bd0007d0f42ecacc247e1b60c8636252fd7450739202b170bf2");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("add_shipping_info", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AddPaymentInfoProperties {
  currency: CurrencyValueType;
  value: number;
  items: Items[];
  nsShop: NsShopValueType;
  salesChannel: string | null | undefined;
}
/**
 * add_payment_info: Web: Final step of the purchase flow. App: Comfirms payment
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: The currency of the purchase
 * @param properties.value: value of purhcased/added/removed item(s)
 * @param properties.items: item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
 * @param properties.nsShop: Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
 * @param properties.salesChannel: Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/X4CYs12Op}
 */
export function addPaymentInfo(properties: AddPaymentInfoProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GuYrcDncVS5", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "1WkP-6sA8x_5", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "Oavl4KfPHF3", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "coupon": value.coupon,
      "discount": value.discount,
      "index": value.index,
      "quantity": value.quantity,
      "price": value.price,
      "item_brand": value.itemBrand,
      "item_variant": value.itemVariant,
      "item_category": value.itemCategory,
      "travel_date": value.travelDate,
      "affiliation": value.affiliation,
      "item_category2": value.itemCategory2,
      "destination_station": value.destinationStation,
      "origin_station": value.originStation,
      "travel_class": value.travelClass,
      "travel_route": value.travelRoute,
      "intercity_direct": value.intercityDirect,
      "deur_tot_deur": value.deurTotDeur,
      "item_revenue": value.itemRevenue,
    }
  })});
  eventPropertiesArray.push({id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop});
  properties.salesChannel !== undefined && properties.salesChannel !== null ?
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel}) :
    eventPropertiesArray.push({id: "qJKae_S4y_", name: "sales_channel", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/add_payment_info/jsonschema/1-0-4"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "X4CYs12Op", "f9fa6c92fdf1c6930a2e5546043b5b4df7cafc2e91eb687d2a4c7ea128ea8a00", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("add_payment_info", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("X4CYs12Op", "add_payment_info", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'add_payment_info': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_payment_info", eventProperties, "X4CYs12Op", "f9fa6c92fdf1c6930a2e5546043b5b4df7cafc2e91eb687d2a4c7ea128ea8a00");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("add_payment_info", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SelectItemProperties {
  itemListId: string | null | undefined;
  itemListName: string | null | undefined;
  listPosition1: number;
  items: Items[];
}
/**
 * select_item: Triggers when a user selects an item in the BCA flow on NS Zakelijk. Acts the same as item_select but is compliant with the GA4 naming convention.
 * 
 * @param properties the properties associatied with this event
 * @param properties.itemListId: id of the list viewed
 * @param properties.itemListName: The name of the list in which the item was presented to the user
 * @param properties.listPosition1: Clicked card is shown on which position in the list
 * @param properties.items: item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/hiBEsJKU3}
 */
export function selectItem(properties: SelectItemProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.itemListId !== undefined && properties.itemListId !== null ?
    eventPropertiesArray.push({id: "qAs6FFElba8q", name: "item_list_id", value: properties.itemListId}) :
    eventPropertiesArray.push({id: "qAs6FFElba8q", name: "item_list_id", value: null});
  properties.itemListName !== undefined && properties.itemListName !== null ?
    eventPropertiesArray.push({id: "LydSjYynFBlR", name: "item_list_name", value: properties.itemListName}) :
    eventPropertiesArray.push({id: "LydSjYynFBlR", name: "item_list_name", value: null});
  eventPropertiesArray.push({id: "xNrM7BXMuKP-", name: "list_position", value: properties.listPosition1});
  eventPropertiesArray.push({id: "Oavl4KfPHF3", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "coupon": value.coupon,
      "discount": value.discount,
      "index": value.index,
      "quantity": value.quantity,
      "price": value.price,
      "item_brand": value.itemBrand,
      "item_variant": value.itemVariant,
      "item_category": value.itemCategory,
      "travel_date": value.travelDate,
      "affiliation": value.affiliation,
      "item_category2": value.itemCategory2,
      "destination_station": value.destinationStation,
      "origin_station": value.originStation,
      "travel_class": value.travelClass,
      "travel_route": value.travelRoute,
      "intercity_direct": value.intercityDirect,
      "deur_tot_deur": value.deurTotDeur,
      "item_revenue": value.itemRevenue,
    }
  })});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/select_item/jsonschema/1-0-3"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "hiBEsJKU3", "a12d4e1363363507b4af34e2ac89478dba717c95bbbbadd468d74bb095628b03", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("select_item", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("hiBEsJKU3", "select_item", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'select_item': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("select_item", eventProperties, "hiBEsJKU3", "a12d4e1363363507b4af34e2ac89478dba717c95bbbbadd468d74bb095628b03");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("select_item", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OrderChangeProperties {
  uniqueName: string;
  description: string;
  clickDestination: string;
  websiteSection: string | null | undefined;
  existingProduct: ExistingProduct[] | null | undefined;
}
/**
 * order_change: Click to change or cancel order from in checkout NS
 * 
 * @param properties the properties associatied with this event
 * @param properties.uniqueName: Unique name / translations string for the element or event
 * @param properties.description: Description of the element or event
 * @param properties.clickDestination: Provide URL if the button navigates
 * @param properties.websiteSection: Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
 * @param properties.existingProduct: current product you up or downgrade (one):
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          item_category2: 'Abonnementen',
          item_variant: 'NS-Flex',
          price: 291.90,
          quantity: 1
        }]
 * 
 * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/iFjz8BD2P1wNMA8uDt1Bq}
 */
export function orderChange(properties: OrderChangeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName});
  eventPropertiesArray.push({id: "OCfm56R0fQu", name: "description", value: properties.description});
  eventPropertiesArray.push({id: "ZRYtNJDfVeyb", name: "click_destination", value: properties.clickDestination});
  properties.websiteSection !== undefined && properties.websiteSection !== null ?
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection}) :
    eventPropertiesArray.push({id: "wskyjid5yxT0", name: "website_section", value: null});
  properties.existingProduct !== undefined && properties.existingProduct !== null ?
    eventPropertiesArray.push({id: "GsMr_TucEDqV", name: "existing_product", value: properties.existingProduct.map(function(value) { return {
        "item_id": value.itemId,
        "item_name": value.itemName,
        "quantity": value.quantity,
        "item_category": value.itemCategory,
        "item_category2": value.itemCategory2,
        "price": value.price,
        "item_brand": value.itemBrand,
        "item_variant": value.itemVariant,
      }
    })}) :
    eventPropertiesArray.push({id: "GsMr_TucEDqV", name: "existing_product", value: null});
  eventPropertiesArray.push({id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/order_change/jsonschema/1-0-0"});
  eventPropertiesArray.push({id: "-PddLxwT_", name: "platform", value: sysPlatform});
  eventPropertiesArray.push({id: "Af3-RL1nz2", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment});
  eventPropertiesArray.push({id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertExistingProductOptional(properties.existingProduct));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "iFjz8BD2P1wNMA8uDt1Bq", "c709efecfc4eeb4eeb6ed977626e9be41ccae3dcafbae0be0ace0b8d3b2647f7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("order_change", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("iFjz8BD2P1wNMA8uDt1Bq", "order_change", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'order_change': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("order_change", eventProperties, "iFjz8BD2P1wNMA8uDt1Bq", "c709efecfc4eeb4eeb6ed977626e9be41ccae3dcafbae0be0ace0b8d3b2647f7");
    }
    // destination NsDataQueue
    NsDataQueue.logEvent("order_change", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  Platform,
  PaymentType,
  Schema,
  Language,
  NsShop,
  Currency,
  CampaignStatus,
  PageType,
  WebsiteVersion,
  NsEnvironment,
  buttonClick,
  linkClick,
  error,
  checkboxClick,
  beginCheckout,
  purchase,
  click,
  formStart,
  formSubmit,
  formError,
  viewItem,
  keuzehulpClick,
  keuzehulpSuccess,
  leadGenerate,
  pageView,
  addToCart,
  removeFromCart,
  datepickerClick,
  selectClick,
  selectableClick,
  expandableClick,
  toggleClick,
  viewItemList,
  addShippingInfo,
  addPaymentInfo,
  selectItem,
  orderChange,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["buttonClick","linkClick","error","checkboxClick","beginCheckout","purchase","click","formStart","formSubmit","formError","viewItem","keuzehulpClick","keuzehulpSuccess","leadGenerate","pageView","addToCart","removeFromCart","datepickerClick","selectClick","selectableClick","expandableClick","toggleClick","viewItemList","addShippingInfo","addPaymentInfo","selectItem","orderChange"]
